document.addEventListener('DOMContentLoaded', function() {
  const preloader = document.getElementById('preloader');
  if (preloader) {
    preloader.style.display = 'none'; // Hide the preloader once the DOM is loaded
  }
});

// Optional: You can also use the 'load' event to wait for all resources (including images) to load
// window.addEventListener('load', function() {
//   const preloader = document.getElementById('preloader');
//   if (preloader) {
//     preloader.style.display = 'none';
//   }
// });